module.exports = __webpack_public_path__ + "img/marketing-1.50c03ee2.svg";